{
  "entry": {
    "title": "醫囑下達",
    "subtitle": "電腦化醫囑下達（CPOE）",
    "searchSection": {
      "title": "搜尋並新增醫囑",
      "cosignNotice": "您的醫囑於生效前需主診醫生會簽。"
    },
    "pending": {
      "title": "待提交醫囑",
      "clearAll": "全部清除",
      "collapseAria": "收起詳情",
      "expandAria": "展開詳情",
      "removeAria": "移除醫囑",
      "startDateTime": "開始日期/時間",
      "ariaStartDate": "醫囑開始日期",
      "ariaStartTime": "醫囑開始時間",
      "clinicalIndication": "臨床適應症",
      "clinicalIndicationPlaceholder": "開立醫囑原因…",
      "specialInstructions": "特殊指示",
      "specialInstructionsPlaceholder": "給執行科室的附加指示…",
      "diagnosisLabel": "診斷（ICD-10）",
      "diagnosisPlaceholder": "搜尋 ICD-10 診斷代碼…",
      "noActiveEncounter": "沒有有效就診 — 無法下達醫囑。",
      "placing": "提交中…",
      "placeAll": "提交全部醫囑（{{count}}）"
    },
    "active": {
      "title": "現行醫囑",
      "loading": "正在載入醫囑…",
      "emptyAll": "找不到此病人的醫囑。",
      "emptyFiltered": "找不到{{type}}醫囑。",
      "columns": {
        "orderNumber": "醫囑編號",
        "name": "名稱",
        "type": "類型",
        "priority": "優先級",
        "status": "狀態",
        "orderedBy": "開立醫生",
        "orderedDate": "開立日期",
        "actions": "操作"
      },
      "external": "外部",
      "externalTitle": "來自 {{source}} 的外部醫囑",
      "externalTitleWithId": "來自 {{source}} 的外部醫囑 (#{{id}})",
      "providerPlaceholder": "醫生 #{{id}}",
      "actions": {
        "complete": "完成",
        "cancel": "取消",
        "completeTooltip": "完成醫囑",
        "cancelTooltip": "取消醫囑"
      }
    },
    "cancelDialog": {
      "title": "取消醫囑",
      "prompt": "請提供取消 {{orderName}} 的原因。",
      "placeholder": "取消原因（必填）…",
      "goBack": "返回",
      "confirm": "確認取消"
    },
    "toast": {
      "cancelSuccess": "醫囑已成功取消",
      "cancelError": "取消醫囑失敗",
      "completeSuccess": "醫囑已標記為完成",
      "completeError": "完成醫囑失敗",
      "noActiveEncounter": "找不到此病人的有效就診。請先建立就診。",
      "placedSuccess_one": "已成功提交 {{count}} 條醫囑",
      "placedSuccess_other": "已成功提交 {{count}} 條醫囑",
      "medicationFieldsRequired_one": "{{names}} 需填寫劑量、給藥途徑和頻次後才能開立",
      "medicationFieldsRequired_other": "{{count}} 種藥物需填寫劑量、給藥途徑和頻次：{{names}}",
      "medicationNotInFormulary_one": "{{names}} 未關聯藥品目錄，無法進行過敏、相互作用或劑量篩查——請在藥物頁面開立",
      "medicationNotInFormulary_other": "{{count}} 種藥物未關聯藥品目錄，無法篩查：{{names}}——請在藥物頁面開立",
      "placedError_one": "{{count}} 條醫囑提交失敗",
      "placedError_other": "{{count}} 條醫囑提交失敗",
      "orderSetApplied": "已從「{{name}}」加入 {{count}} 項醫囑——簽署前請覆核"
    }
  },
  "catalog": "醫囑目錄",
  "orderedBy": "開立醫生",
  "orderedDate": "開立日期",
  "scheduledDate": "排期日期",
  "completedDate": "完成日期",
  "lab": "檢驗",
  "imaging": "影像",
  "medication": "藥物",
  "procedure": "手術/處置",
  "consultation": "會診",
  "priority": {
    "label": "優先順序",
    "values": {
      "stat": "STAT",
      "asap": "ASAP",
      "urgent": "急件",
      "routine": "常規",
      "scheduled": "已排期",
      "prn": "PRN"
    }
  },
  "status": {
    "label": "醫囑狀態",
    "values": {
      "draft": "草稿",
      "pending": "待處理",
      "pendingCosign": "待會簽",
      "signed": "已簽核",
      "sent": "已發送",
      "active": "生效中",
      "ordered": "已開立",
      "inProgress": "執行中",
      "holdForVerify": "待核對",
      "completed": "已完成",
      "cancelled": "已取消",
      "discontinued": "已停止",
      "archived": "已封存",
      "pendingClarification": "待澄清",
      "suspended": "已暫停",
      "unknown": "未知"
    }
  },
  "entryFields": {
    "searchPlaceholder": "搜尋醫囑（檢驗、影像、藥物、處置）…",
    "frequency": "頻次",
    "dose": "劑量",
    "route": "給藥途徑",
    "indication": "適應症",
    "duration": "持續時間",
    "comments": "備註",
    "signOrder": "簽核醫囑",
    "holdOrder": "暫緩醫囑",
    "frequencyOptions": {
      "stat": "STAT",
      "prn": "PRN",
      "bid": "BID",
      "tid": "TID",
      "qid": "QID",
      "qd": "QD",
      "qhs": "QHS",
      "ac": "AC",
      "pc": "PC"
    }
  },
  "catalogPage": {
    "title": "醫囑目錄",
    "searchPlaceholder": "按名稱、代碼或同義詞搜尋…",
    "categories": "分類",
    "favorites": "我的最愛",
    "recentlyUsed": "最近使用",
    "restricted": "受限項目",
    "searchCatalog": "搜尋目錄",
    "tabs": {
      "all": "全部",
      "lab": "檢驗",
      "imaging": "影像",
      "medication": "藥物",
      "procedure": "處置",
      "consultation": "會診"
    },
    "columns": {
      "orderName": "醫囑名稱",
      "code": "代碼",
      "category": "類別",
      "description": "描述",
      "defaultPriority": "預設優先順序"
    },
    "details": {
      "orderCode": "醫囑代碼",
      "category": "類別",
      "defaultPriority": "預設優先順序",
      "status": "狀態",
      "cptCode": "CPT 代碼",
      "loincCode": "LOINC 代碼",
      "synonyms": "同義詞",
      "description": "描述",
      "active": "啟用",
      "inactive": "停用"
    },
    "loading": "正在載入目錄…",
    "loadError": "載入醫囑目錄失敗",
    "emptyResults": "找不到符合條件的醫囑。",
    "pagination": "顯示第 {{from}}-{{to}} 項，共 {{total}} 項",
    "pageIndicator": "第 {{page}} 頁，共 {{totalPages}} 頁",
    "favoriteAdd": "加入我的最愛",
    "favoriteRemove": "從我的最愛移除",
    "favoriteAdded": "已加入我的最愛",
    "favoriteRemoved": "已從我的最愛移除"
  },
  "cosign": {
    "title": "醫囑會簽佇列",
    "requiresCosign": "需要會簽",
    "cosignedBy": "會簽者",
    "cosignDeadline": "會簽限期",
    "queueEmpty": "沒有需要會簽的醫囑。",
    "pendingCount": "待處理 {{count}} 項",
    "loading": "正在載入會簽佇列…",
    "loadError": "載入會簽佇列失敗。",
    "columns": {
      "patient": "病人",
      "order": "醫囑",
      "type": "類型",
      "orderingProvider": "開立醫生",
      "priority": "優先順序",
      "orderedDate": "開立日期",
      "action": "操作"
    },
    "actions": {
      "cosign": "會簽"
    },
    "toast": {
      "success": "醫囑會簽成功",
      "error": "醫囑會簽失敗"
    },
    "cosigningAs": "以 {{name}} 身分會簽"
  },
  "sets": {
    "title": "醫囑套組",
    "newOrderSet": "新增醫囑套組",
    "addItem": "新增項目",
    "requiredItem": "必選",
    "optionalItem": "可選",
    "editMode": "編輯模式",
    "published": "已發布",
    "draft": "草稿",
    "archived": "已封存",
    "versionNotes": "版本說明",
    "createTitle": "建立新醫囑套組",
    "fields": {
      "name": "名稱",
      "category": "類別",
      "specialty": "專科",
      "description": "描述"
    },
    "placeholders": {
      "name": "例如：胸痛檢查",
      "categorySelect": "選擇類別…",
      "specialty": "例如：急症科",
      "description": "簡短描述…",
      "search": "搜尋醫囑套組…"
    },
    "categories": {
      "chestPain": "胸痛",
      "sepsis": "敗血症",
      "postOp": "術後",
      "admission": "入院",
      "discharge": "出院",
      "other": "其他"
    },
    "statusFilter": {
      "all": "所有狀態",
      "active": "生效",
      "draft": "草稿",
      "archived": "已封存"
    },
    "columns": {
      "name": "名稱",
      "category": "類別",
      "specialty": "專科",
      "items": "項目數",
      "status": "狀態",
      "version": "版本",
      "actions": "操作"
    },
    "itemColumns": {
      "seq": "序號",
      "type": "類型",
      "item": "項目",
      "priority": "優先順序",
      "required": "必選"
    },
    "itemTypes": {
      "order": "醫囑",
      "sectionHeader": "分節標題",
      "instruction": "說明"
    },
    "actions": {
      "publish": "發布",
      "archive": "封存",
      "cancel": "取消",
      "create": "建立",
      "removeItem": "移除項目"
    },
    "loading": "正在載入醫囑套組…",
    "loadError": "載入醫囑套組失敗",
    "emptyResults": "找不到醫囑套組。",
    "expandLoading": "正在載入項目…",
    "expandEmpty": "此醫囑套組沒有項目。",
    "validationRequired": "名稱、類別和專科為必填項",
    "toast": {
      "created": "醫囑套組已建立",
      "createError": "建立醫囑套組失敗",
      "published": "醫囑套組已發布",
      "publishError": "發布醫囑套組失敗",
      "archived": "醫囑套組已封存",
      "archiveError": "封存醫囑套組失敗",
      "itemRemoved": "項目已移除",
      "itemRemoveError": "移除項目失敗"
    },
    "versionBadge": "v{{version}}"
  },
  "search": {
    "placeholder": "搜尋醫囑（檢驗、影像、藥物、處置）…",
    "noResults": "找不到與 \"{{query}}\" 相符的醫囑",
    "categories": {
      "all": "全部",
      "lab": "檢驗",
      "imaging": "影像",
      "med": "藥物",
      "procedure": "處置",
      "consultation": "會診"
    },
    "addAll": "全部加入（{{count}}）"
  },
  "worklist": {
    "title": "醫囑工作清單",
    "countBadge": "{{count}} 張醫囑",
    "loading": "正在載入醫囑…",
    "loadError": "無法載入醫囑，請重試。",
    "empty": "沒有符合目前篩選條件的醫囑。",
    "typeLabel": "醫囑類型",
    "allOption": "全部",
    "columns": {
      "patient": "病人",
      "order": "醫囑",
      "type": "類型",
      "priority": "優先次序",
      "status": "狀態",
      "ordered": "開立時間"
    }
  }
}
